import React from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { Spinner } from '@salesforce/design-system-react/';

import * as I18nActions from '../actions';
import messages from '../messages';

export const SessionContext = React.createContext({ readOnly: false });
export const withSession = componentFunc => {
  return (
    <SessionContext.Consumer>
      {session => componentFunc(session)}
    </SessionContext.Consumer>
  );
};

class AppInit extends React.Component {
  componentDidMount() {
    const { locale, useBlockSdk } = this.props;
    this.props.actions.getLocale({ locale, useBlockSdk });
    this.props.actions.getSession();
  }

  componentDidUpdate(prevProps) {
    if (this.props.locale !== prevProps.locale) {
      const { locale, useBlockSdk } = this.props;
      this.props.actions.getLocale({ locale, useBlockSdk });
    }
  }

  renderSpinnerOrChildren(isLoading) {
    return isLoading ? (
      <div className="pi-common-spinner">
        <Spinner variant="brand" />
      </div>
    ) : (
      this.props.children
    );
  }

  render() {
    const { isLoading, locale, messages, session } = this.props;
    return (
      <IntlProvider locale={locale} messages={messages}>
        <SessionContext.Provider value={session}>
          {this.renderSpinnerOrChildren(isLoading)}
        </SessionContext.Provider>
      </IntlProvider>
    );
  }
}

AppInit.defaultProps = {
  locale: 'en',
  messages: messages.en,
  isLoading: true
};

AppInit.propTypes = {
  actions: PropTypes.shape({
    getLocale: PropTypes.func.isRequired,
    getSession: PropTypes.func.isRequired
  }).isRequired,
  children: PropTypes.element,
  locale: PropTypes.string,
  session: PropTypes.object,
  messages: PropTypes.object,
  useBlockSdk: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    locale: state.i18n.locale,
    messages: state.i18n.messages,
    isLoading: state.i18n.isLoading,
    session: state.i18n.session
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(I18nActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppInit);
